const images = {
	"logo": require("./logo.png"),
	"pdf": require("./pdf.png"),
	"info": require("./info.png"),
	"file-corrupted": require("./file-corrupted.png"),
};

export default images;
